import {
  computed,
  watch,
  reactive,
  toRefs,
  PropType,
  Ref,
  ref,
  onMounted
} from 'vue'

import { DonutChart, LineChart, SimpleBarChart, HeatmapChart } from '@carbon/charts'
import { defaultsDeep } from 'lodash'
import { AxisChartOptions, ChartConfig, DonutChartOptions, LineChartOptions, HeatmapChartOptions } from '@carbon/charts/interfaces'
import { Chart } from '@carbon/charts/chart'
import { AxisChart } from '@carbon/charts/axis-chart'

const DEFAULT_CHART_CONFIG = {
  title: '',
  axes: {
    left: {
      mapsTo: 'value'
    },
    bottom: {
      scaleType: 'labels',
      mapsTo: 'key'
    }
  },
  // width: '600px',
  height: '300px'
}

export function useAxisChart <O extends HeatmapChartOptions, C extends typeof HeatmapChart = typeof HeatmapChart, I extends ChartConfig<O> = ChartConfig<O>> (props, ChartType: C, containerElementRef?:Ref<Element | undefined>, config?:O) {
  const chart = ref<InstanceType<C>>()
  const dom_container = containerElementRef || ref<Element>()

  const options = ref<O>(defaultsDeep({ ...(props.config || {}) }, (config || DEFAULT_CHART_CONFIG)))
  const data = computed(() => props.payload)

  const chartConfig = ref<I>({
    data: data.value,
    options: options.value
  } as any)

  function updateData () {
    chart.value?.model.setData(data.value)
  }

  function updateOptions () {
    chart.value?.model.setData(options.value)
  }

  watch(() => data.value, updateData)
  watch(() => options.value, updateOptions)

  function mountedHook (container = dom_container) {
    if (!container.value) {
      console.warn('Chart container ref was not set, make sure to reference "dom_container" on 1 element in your template')
      return
    }
    chart.value = new ChartType(container.value, chartConfig.value) as InstanceType<C>
  }
  onMounted(mountedHook)

  return {
    chart,
    options,
    data,
    dom_container,
    mountedHook,
    update: {
      data: updateData,
      options: updateOptions
    }
  }
}
